import { memo } from 'react'
import { PropsDataContratos } from '../Pagos/ModalTablePagos'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { format } from 'date-fns'
import { CheckCircleOutline } from '@mui/icons-material'

/* eslint-disable react/prop-types */

interface Props extends PropsDataContratos {
  handleOpenHistorial: (item: any) => void
}

const ModalCardsPagos: React.FC<Props> = ({
  show,
  loading,
  data,
  handleClose,
  headers,
  title,
  handleOpenHistorial
}) => {
  return (
    <Dialog
      open={show}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          overflowX: 'hidden',
          marginLeft: '-1rem',
          width: '90%'
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box>
          {data.items?.map((item, index) => {
            const fecha = new Date(item.fechaPago)
            return (
              <Box sx={{ p: 1, m: '1rem 0', boxShadow: 1, width: 'auto' }} key={index}>
                <Box>
                  <Typography variant="body1">Pago: {item.contratoPagoEstado}</Typography>
                  <Typography variant="body1">
                    {`Pagado: ${item.monto}`}
                    {item.montoDevuelto > 0 && `\nDevuelto: ${item.montoDevuelto}`}
                    {item.saldoAplicado > 0 && `\nSaldo Aplicado: ${item.saldoAplicado}`}
                  </Typography>
                  <Typography variant="body1">Fecha: {format(fecha, 'dd/MM/yyyy HH:mm:ss')}</Typography>
                  <Typography variant="body2">Nro de operación: {item.pagoNroOperacion}</Typography>
                  <Typography variant="body2">
                    {item.mensajeResultado}
                    {item.nuevoContrato && <CheckCircleOutline style={{ marginLeft: '8px', color: 'green' }} />}
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleOpenHistorial(item)}
                    sx={{ marginTop: '0.6rem' }}
                  >
                    Historial de cambios
                  </Button>
                </Box>
              </Box>
            )
          })}
        </Box>
      </DialogContent>
      <DialogActions>
        <button onClick={handleClose} className="btn btn-secondary">
          Cerrar
        </button>
      </DialogActions>
    </Dialog>
  )
}

export default memo(ModalCardsPagos)
